import { render, staticRenderFns } from "./UiOverlay.vue?vue&type=template&id=6012c82a&scoped=true&"
import script from "./UiOverlay.vue?vue&type=script&lang=js&"
export * from "./UiOverlay.vue?vue&type=script&lang=js&"
import style0 from "./UiOverlay.vue?vue&type=style&index=0&id=6012c82a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6012c82a",
  null
  
)

export default component.exports